import { IApplicationState } from '../../types/redux';

export function getNewbuildingId(state: IApplicationState) {
  const {
    newbuilding: { id },
  } = state;

  return id;
}
